import replaceProductImages from './lib/product-images';
import './scss/foodservice.scss';

replaceProductImages();
